import React from "react";

const BasicTextInput = ({
  label,
  tooltip,
  value,
  onChange,
  placeholder,
  id,
  name,
  type,
  isRequired,
  disabled,
  maxWidth,
}) => {
  return (
    <div
      style={{ maxWidth: maxWidth }}
      className="flex flex-col space-y-1 mb-4"
    >
      <label htmlFor={name} className="text-gray-700 font-medium text-sm">
        {label}
        {isRequired && (
          <span className="text-xs text-gray-500">(required)</span>
        )}
      </label>
      <input
        type={type || "text"}
        id={id}
        name={name}
        placeholder={placeholder || ""}
        onChange={onChange}
        value={value}
        className="text-sm border border-gray-300 rounded-lg p-2 text-gray-900 focus:outline-none focus:ring-2 focus:ring-secondary focus:border-transparent"
        aria-describedby="tooltip"
        disabled={disabled}
      />
      {tooltip && (
        <p id="tooltip" className="text-xs text-gray-500">
          {tooltip}
        </p>
      )}
    </div>
  );
};

const MultiTextInput = ({
  label,
  tooltip,
  value1,
  onChange1,
  placeholder1,
  id1,
  name1,
  type1,
  isRequired1,
  value2,
  onChange2,
  placeholder2,
  id2,
  name2,
  type2,
  isRequired2,
}) => {
  return (
    <div className="flex flex-col space-y-1 mb-4">
      <label htmlFor="name" className="text-gray-700 font-medium text-sm">
        {label}
        {(isRequired1 || isRequired2) && (
          <span className="text-xs text-gray-500">(required)</span>
        )}
      </label>

      <div className="flex gap-2 items-center">
        <div className="w-4/12">
          <input
            type={type1 || "text"}
            id={id1}
            name={name1}
            placeholder={placeholder1 || ""}
            onChange={onChange1}
            value={value1}
            className="text-sm w-full border border-gray-300 rounded-lg p-2 text-gray-900 focus:outline-none focus:ring-2 focus:ring-secondary focus:border-transparent"
            aria-describedby="tooltip"
          />
        </div>
        <div className="w-8/12">
          <input
            type={type2 || "text"}
            id={id2}
            name={name2}
            placeholder={placeholder2 || ""}
            onChange={onChange2}
            value={value2}
            className="text-sm w-full border border-gray-300 rounded-lg p-2 text-gray-900 focus:outline-none focus:ring-2 focus:ring-secondary focus:border-transparent"
            aria-describedby="tooltip"
          />
        </div>
      </div>

      {tooltip && (
        <p id="tooltip" className="text-xs text-gray-500">
          {tooltip}
        </p>
      )}
    </div>
  );
};

export { BasicTextInput, MultiTextInput };
